import React from 'react';
import './inbox.scss';
import { Tabs } from 'antd';
import { useTranslator } from 'tools/view-hooks/translator-hook';
import { useInboxController } from './inbox.controller';
import { AnnouncementsTabFragment } from './fragments/announcements-tab/announcements-tab.fragment';
import { NotificationListFragment } from 'fragments/notification/fragments/notification-list/notification-list.fragment';

const { TabPane } = Tabs;

export const InboxFragment: React.FC = () => {
    const { translate } = useTranslator();
    const { state, events } = useInboxController();

    return (
        <div className={'inbox'}>
            <Tabs activeKey={state.activeTab} onChange={events.onChangeTab} centered>
                <TabPane key={'announcements'} tab={translate({ key: 'inbox.tab-announcements' })}>
                    <AnnouncementsTabFragment />
                </TabPane>
                <TabPane key={'notifications'} tab={translate({ key: 'inbox.tab-notifications' })}>
                    <NotificationListFragment />
                </TabPane>
            </Tabs>
        </div>
    );
};
